<template>
  <!--
    @name: TopicsTitle.vue
    @description:
    @author:  XueRunBing
    @time: 2021/2/6 14:50
  -->

    <div class="title">
        <!-- <span class="title-decorate" :style="'width:'+num">
            <img src="../../assets/image/article/title-bar.png" alt="">
        </span> -->
        <span class="title-text" ref="pageContainer">{{title}}</span>
        <!-- <span  class="title-decorate" :style="'width:'+num">
            <img src="../../assets/image/article/title-bar.png" alt="">
        </span> -->
    </div>

</template>

<script>

export default {
  name: 'TopicsTitleCompontent',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      num: ''
    }
  },
  components: {
  },
  mounted () {
    let width = this.$refs.pageContainer.offsetWidth
    if (width > 80 && width <= 90) {
      this.num = '100px'
    } else if (width > 90 && width <= 100) {
      this.num = '90px'
    } else if (width > 100 && width <= 110) {
      this.num = '80px'
    } else if (width > 110 && width <= 120) {
      this.num = '70px'
    } else if (width > 120 && width <= 130) {
      this.num = '60px'
    } else if (width > 130 && width <= 140) {
      this.num = '50px'
    } else if (width > 140 && width <= 150) {
      this.num = '60px'
    } else if (width > 150 && width <= 160) {
      this.num = '50px'
    } else if (width > 160 && width < 250) {
      this.num = '40px'
    } else if (width >= 250) {
      this.num = '0px'
    }
  },
  computed: {
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>

.title{
    width: 100%;
    text-align: center;
    .title-decorate{
      display: inline-block;
      overflow: hidden;
        img{
            height: 7px;
            // display: inline-block;
        }
    }
    .title-text{
        font-size: 18px;
        font-family: 'SourceHanSansSC';
        font-weight: 600;
        vertical-align:middle
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Topics/TopicsTitle.vue